import React from 'react';
import { Typography, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';

function UnauthorizedPage() {
  return (
    <Box
      sx={{
        minHeight: '70vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Typography variant="h3" gutterBottom>
        Zugriff verweigert
      </Typography>
      <Typography variant="h6" gutterBottom>
        Sie verfügen nicht über die notwendigen Rechte, um auf diese Seite zuzugreifen.
      </Typography>
      <Button
        component={Link}
        to="/"
        variant="contained"
        color="primary"
        sx={{ mt: 2 }}
      >
        Zur Startseite
      </Button>
    </Box>
  );
}

export default UnauthorizedPage;
